import React, { Component, Fragment } from 'react';
import { AuthGate } from '../Auth';
import Button from '../Button';
import { saveAs } from 'file-saver';
import { FormattedHTMLMessage } from 'react-intl';


export default class AdminButton extends Component {

  fetchReport() {
    fetch(`${window.BACKEND_ENDPOINT}/downloadIfValid`, {
      /* headers: { 'Accept': 'application/vnd.ms-excel' }, */
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob();
    })
      .then((myBlob) => {
        saveAs(myBlob, 'Report.xlsx');
      })
      .catch((error) => {
        console.error('There has been a problem with your fetch operation:', error);
      });
  }

  render() {
    return (
      <AuthGate>
        {({ user }) => (
          <Fragment>
            {
              user && user.isAdmin && <Button onClick={() => this.fetchReport()}><FormattedHTMLMessage id='admin.donwload-report:button' /></Button>
            }
          </Fragment>
        )}
      </AuthGate>
    )
  }
}